const baseUrl = 'https://mobile-api.pedidosya.com/mobile'

export default {
  appInit: ({ simulatedPlatform = 'ios' } = {}) =>
    `${baseUrl}/v2/functions/appInit?app=${simulatedPlatform}`,
  initialData: ({ includeFoodCategory = true } = {}) =>
    `${baseUrl}/v3/functions/countries/1/initialData?includeFoodCategory=${includeFoodCategory}`,
  getEstablishmentMenu: ({ id = -1, maxLayout = 3 } = {}) =>
    `${baseUrl}/v3/restaurants/${id}/menu?maxLayout=${maxLayout}`
}
